export default function getOfferWebsite(landingPageUrl) {
  if (typeof landingPageUrl !== 'string' || !landingPageUrl.trim()) return null

  try {
    const url = new URL(landingPageUrl.trim())
    if (!['https:', 'http:'].includes(url.protocol)) return null

    return {
      href: url.href,
      domain: url.hostname.replace(/^www\./, '')
    }
  } catch (error) {
    return null
  }
}
